module.exports = "/images/logo_small.png?a89a745b977a8a0f7fc3258ac6e17dbd";